import React from 'react';
import './LoopyMark.css';

interface LoopyMarkProps {
  size?: number;
  className?: string;
}

const LoopyMark: React.FC<LoopyMarkProps> = ({ size = 24, className = '' }) => {
  return (
    <span
      className={`loopy-mark ${className}`.trim()}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <img src="/avatars/loopy-avatar.png" alt="" draggable={false} />
    </span>
  );
};

export default LoopyMark;
